import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {WeeeSystemSearch} from '../models/weee_system_search.interface';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable, throwError} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {WeeeSystems} from '../models/weee_systems.interface';
import {environment} from '../../../environments/environment';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';
import {User} from '../../kf-data-entry/models/user.interface';

const WEEE_SYSTEM_API = environment.apiUrl + 'weeesystems';

@Injectable({
  providedIn: 'root'
})
export class WeeeSystemService {

  constructor(private http: HttpClient) { }

  static buildSearchParams(search: WeeeSystemSearch): string {
    let searchParams = '';
    if (search.description && search.description !== '') {
      searchParams += `&description=${search.description}`;
    }
    if (search.countryName && search.countryName !== '') {
      searchParams += `&countryName=${search.countryName}`;
    }
    if (search.isMember || search.isMember === false) {
      searchParams += `&isMember=${search.isMember}`;
    }
    if (search.status) {
      searchParams += `&status=${search.status}`;
    }
    return searchParams;
  }

  getAll(search: WeeeSystemSearch, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<WeeeSystems>> {
    let url = `${WEEE_SYSTEM_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = WeeeSystemService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<WeeeSystems>>(url + searchParams);

  }

  getWeeeSystemUsers(id: number, pageRequest: PageRequest = {page: 0, size: 5}): Observable<Page<User>> {
    let url = `${WEEE_SYSTEM_API}/users?size=${pageRequest.size}&page=${pageRequest.page}`;
    let params = '';
    params += '&weeeSystemId=' + id;
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<User>>(url + params);
  }

  createWeeeSystem(dto: WeeeSystems): Observable<ApiHttpResponse<WeeeSystems>> {
    return this.http.post<ApiHttpResponse<WeeeSystems>>(`${WEEE_SYSTEM_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<WeeeSystems>) => {
          return res;
        })
      );
  }

  editWeeeSystem(dto: WeeeSystems): Observable<ApiHttpResponse<WeeeSystems>> {
    return this.http.put<ApiHttpResponse<WeeeSystems>>(`${WEEE_SYSTEM_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<WeeeSystems>) => {
          return res;
        })
      );
  }

  updateWeeeSystem(id: number): Observable<ApiHttpResponse<WeeeSystems>> {
    return this.http.put<ApiHttpResponse<WeeeSystems>>(`${WEEE_SYSTEM_API}/update`, id)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<WeeeSystems>) => {
          return res;
        })
      );
  }

  deleteWeeeSystem(id: number): Observable<HttpResponse<any>> {
    return this.http.delete(`${WEEE_SYSTEM_API}/${id}`, {observe: 'response'})
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  private getSortCode(sort: string): string {
    switch (sort) {
      case 'open':
        return 'isReportingAvailable';
      default:
        return sort;
    }
  }
}
